var render, staticRenderFns
import script from "./CustomDivDownload.vue?vue&type=script&lang=js"
export * from "./CustomDivDownload.vue?vue&type=script&lang=js"
import style0 from "./CustomDivDownload.vue?vue&type=style&index=0&id=4dae35c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dae35c9",
  null
  
)

export default component.exports